/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CollectedServiceService } from './services/collected-service.service';
import { CustomerService } from './services/customer.service';
import { LoginService } from './services/login.service';
import { RaiFormService } from './services/rai-form.service';
import { RaifragenService } from './services/raifragen.service';
import { ScheduleService } from './services/schedule.service';
import { ServiceService } from './services/service.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CollectedServiceService,
    CustomerService,
    LoginService,
    RaiFormService,
    RaifragenService,
    ScheduleService,
    ServiceService,
    ApiConfiguration
  ],
})
export class BackendApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BackendApiModule> {
    return {
      ngModule: BackendApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: BackendApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BackendApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
